import { useEffect, useState } from 'react';
import { fixNumbers, unhandledErrorGenerator, useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { RootStackType } from 'Router';
import { useAlert } from '@rahtab/ui';

export const useCheckUser = () => {
  const [userVerified, setUserVerified] = useState(false);
  const [check, { data, loading }] = useFetchCallType<UserValidation>('CheckCustomerInfo', { skip: true });
  const { navigate } = useNavigation<NavigationProp<RootStackType>>();
  const alert = useAlert();
  useEffect(() => {
    if (!loading && data) {
      const { error, name, valid } = data;
      if (valid === 'true') {
        setUserVerified(true);
        navigate('Products', { sell: true, customerName: name });
      } else if (valid === 'false') {
        if (error) {
          alert({ message: error, title: 'خطا' });
        } else {
          alert(unhandledErrorGenerator(501));
        }
      } else alert(unhandledErrorGenerator(502));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const checkUser = async ({ userId, userPass, userType }: CheckUser) => {
    check({
      params: `NationalCode=${userType}${fixNumbers(userId)}&PinCode=${fixNumbers(userPass)}`,
    });
  };
  return {
    checkUser: { checkUser, checkUserLoading: loading, userVerified },
  };
};

export default useCheckUser;

export const UserType = {
  CITIZEN: 'citizen:',
  IMMIGRANT: 'immigrant:',
  CARD: 'card:',
} as const;

export interface CheckUser {
  userId: string;
  userPass: string;
  userType: typeof UserType[keyof typeof UserType];
}

export interface UserValidation {
  name: string;
  valid: string;
  error: string;
}
